import { FunctionComponent, memo } from 'react';
import { HorizontalStoryFeedCard } from './HorizontalStoryFeedCard';
import { HorizontalStoryFeedCommon, PaginationInfo, getStoryTabItemsLink } from '../../shared';
import { useNavigate } from 'react-router-dom';
import { Story, StoryCard } from '../../services';

interface HorizontalStoryFeedProps {
  story: Story;
  cards: StoryCard[];
  pageInfo: PaginationInfo;
  zIndex: number;
}

export const HorizontalStoryFeed: FunctionComponent<HorizontalStoryFeedProps> = memo(
  ({ story, cards, pageInfo, zIndex }) => {
    const navigate = useNavigate();

    return (
      <HorizontalStoryFeedCommon
        story={story}
        cards={cards}
        pageInfo={pageInfo}
        zIndex={zIndex}
        CardComponent={HorizontalStoryFeedCard}
        viewAllClick={() => navigate(getStoryTabItemsLink({ story }))}
      />
    );
  }
);
